const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: '${label}を入力してください',
};

export default validateMessages;
